import structureTypes from 'common/constants/structureTypes'
import ServerPage from 'server/types/ServerPageInterface'
import { migrateCommand } from '../utils/migrateCommand'
import { migratePaymentMethod } from './migratePaymentMethod'

export default function (page: ServerPage): [ServerPage, boolean] {
  return migrateCommand({
    page,
    structureType: structureTypes.PAYMENT_METHOD,
    migrateFunction: migratePaymentMethod,
  })
}
